import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

/* === TABLE PROPS ==================================================================== */
interface Props {
  title: string;
  items: {
    title: string;
    description: string;
  }[];
  disclaimer?: string;
  backgroundColor?: string;
}

export const Table = ({ title, items, disclaimer, backgroundColor }: Props) => {
  /* === RENDER ======================================================================= */
  return (
    <Box component="section" bgcolor={backgroundColor} py={{ xs: 5, md: 12.5 }}>
      <Box className="container" px={{ xs: 3, md: 1 }}>
        <Grid container spacing="6px" justifyContent="center" color="black">
          <Grid item xs={3} />
          <Grid item xs={9}>
            <Box
              minHeight="50px"
              bgcolor="#272031"
              width="100%"
              height="100%"
              sx={{ borderTopLeftRadius: '14px', borderTopRightRadius: '14px' }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              px={3}
            >
              <Typography color="white" fontSize={20} fontFamily="Gotham-Bold" m={0} p={0}>
                <RawHtml content={title} />
              </Typography>
            </Box>
          </Grid>

          {items.map((item, index) => {
            const isFirstRow = index === 0;
            const isLastRow = index === items.length - 1;

            return (
              <React.Fragment key={index}>
                <Grid item xs={3} key={index} minHeight="50px">
                  <Box
                    width="100%"
                    height="100%"
                    bgcolor="#F3F2F5"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    px={3}
                    sx={{ borderTopLeftRadius: isFirstRow ? '14px' : '0', borderBottomLeftRadius: isLastRow ? '14px' : '0' }}
                  >
                    <Typography color="#272031" fontSize="14px" p={0} mb={0} fontFamily="Gotham-Medium" sx={{ '& p': { mb: 0 } }}>
                      <RawHtml content={item.title} />
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={9} key={index}>
                  <Box
                    width="100%"
                    height="100%"
                    bgcolor="#F3F2F5"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    minHeight="50px"
                    px={3}
                    sx={{ borderBottomRightRadius: isLastRow ? '14px' : '0' }}
                  >
                    <Typography color="#232529" fontSize="14px" p={0} mb={0} fontFamily="Gotham-Book" sx={{ '& p': { mb: 0 } }}>
                      <RawHtml content={item.description} />
                    </Typography>
                  </Box>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>

        {disclaimer ? (
          <Typography color="#B1B1B2" fontSize={14} fontFamily="Gotham-Book" mt={2} textAlign="center">
            {disclaimer}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
